export const UPLOAD_TYPE = {
  RECORD_SCREEN: "RecordScreen",
  LOCAL_VIDEO: "LocalImport",
  ZOOM_IMPORT: "ImportFromZoom",
  MMSOP: "MMSOP",
};
